import {MessageBusEvent, MessageBusEventType} from "@getgo/message-bus-js-sdk";

class TangramPlayerEvent extends MessageBusEvent {
  static get EVENT_TYPES() {
    return {
        SEEK: 'SEEK',
        PROGRESS: 'PROGRESS',
        PAUSE: 'PAUSE',
        LOADED: 'LOADED'
    }
  }

  static get PAUSE_STATES() {
    return {
        BUFFERING: 'BUFFERING',
        PLAYING: 'PLAYING',
        UNKNOWN: 'UNKNOWN'
    }
  }

  constructor(props = {}){
    const
      // App specific properties
      namespace = 'com.logmein.goto.unifiedplayer',
      eventSource = 'unifiedPlayer',
      eventType = MessageBusEventType.INFO,

      // Event specific properties
      eventVersion = '1-0-0',
      eventName = 'playerEvent',
      payload = {};

    super({
      namespace, eventSource, eventType,
      eventVersion, eventName, payload,
      ...props
    });
  }

}

export default TangramPlayerEvent;
